/**
 * Constantes anti-spam compartilhadas entre o componente CLIENTE (Component.tsx / TurnstileWidget) e o
 * hook de SERVIDOR (antiSpam.ts). Mantido SEM imports de `payload` para não puxar código de servidor
 * para o bundle do cliente.
 */

/**
 * Nome do campo honeypot (oculto) injetado pelo form. Bots que preenchem TODOS os inputs caem nele;
 * humano nunca o vê. Prefixo `hp_` garante que NÃO colide com nenhum campo real do form (ex.: um form de
 * anunciante pode ter um campo "website" legítimo — a colisão bloquearia um humano por engano).
 */
export const HONEYPOT_FIELD = 'hp_field'
